import { TCMResponseDataItem, TCMResponseGroup, TCMResponseGroupService } from "@nt-portal/tcm-sdk";
import { ControllerOptions, DataController } from "../../../../types";
import { BaseClientService } from "../../base-client.service";
import { ResultData } from "@nt-portal/common-sdk";
import { createTCMScheduleSheet } from "../schedule";


export interface TCMResponseGroupOptions extends ControllerOptions<TCMResponseGroup> {
    sheetId: string;
}

export const initTCMResponseGroup = (inObj: Partial<TCMResponseGroup>) => {
    let item: TCMResponseGroup = {
        id: "",
        ranking: 0,
        price: 0,
        sheet: inObj.sheet ?? createTCMScheduleSheet({}),
        createdBy: ""
    }
    return item;
}


export class ClientTCMResponseGroupService extends BaseClientService implements DataController<TCMResponseGroup> {

    private _service: TCMResponseGroupService;


    constructor() {
        super();
        this._service = new TCMResponseGroupService({
            apiService: this.apiService,
            url: this.settings.tcmServer
        });
    }

    public set params(params: any) {
        this._service.params = params;
    }

    public get params() {
        return this._service.params ?? {};
    }

    public async get(options: TCMResponseGroupOptions): Promise<ResultData<TCMResponseGroup>> {

        if (this.params.scheduleId) {
            return await this._service.getByFilter(this.buildFetchParams(options), this.token, options.sheetId, options.filter);
        } else {
            throw new Error("Schedule ID is required to fetch response item groups.");
        }
    }

    public async getLookup(options: TCMResponseGroupOptions): Promise<ResultData<TCMResponseGroup>> {
        let fetchParams = this.buildLookupFetchParams(options);
       
       if (this.params.scheduleId) {
            return await this._service.getByFilter(fetchParams, this.token, options.sheetId, options.filter);
        } else {
            throw new Error("Schedule ID is required to fetch response item groups.");
        }
    }

    // public async update(options: TCMResponseGroupOptions): Promise<TCMResponseGroup | TCMResponseGroup[] | null> {
    //     if (options.item && options.item.id && this.params.responseId)
    //         return await this._service.update(options.item.id, options.item, this.token)
    //     return null;
    // }
}
